import { inject, injectable } from 'inversify';

import { HttpService } from 'src/core/services/http.service';

export interface IStackTraceMessage {

	ruleId: number;
	date: Date;
	trace: IStackTraceMessage[];
	level: number;
	sessionId: string;
	header: string;
}

@injectable()
export class RuleOperationsService {
	@inject(HttpService)
	private httpService: HttpService;

	private baseUrl = 'api/v1/rules/services';

	public async toggleRuleActivation(ruleId: number, activate: boolean): Promise<boolean> {
		return (await this.httpService.post(`${this.baseUrl}/activate`, { ruleId, activate })).data;
	}

	public async getStackTrace(ruleId: number, pageSize: number = 100, pageIndex: number = 0): Promise<{ total: number, pageIndex: number, pageSize: number, items: any[] }> {
		return (await this.httpService.post(`${this.baseUrl}/stacktrace`, {
			id: ruleId,
			pageSize,
			pageIndex
		})).data;
	}

	public async getEventDefinition(classPath: string): Promise<PublicEventItem> {
		return (await this.httpService.post(`${this.baseUrl}/event`, {
			classPath
		})).data;
	}

	public async runManually(ruleId: number): Promise<any> {
		this.httpService.get(`${this.baseUrl}/run/${ruleId}`);
	}

}



// WEBPACK FOOTER //
// ./src/app/rules/rules/rule-services.ts